export const EPaymentType = {
  None: 0,

  Cash: 1,

  Card: 2,

  Pix: 3,

  CreditCard: 4,

  DebitCard: 5,

  Other: 6,

  FoodVoucher: 7,

  MealVoucher: 8,

  TapToPay: 9,
} as const

export type EPaymentType = (typeof EPaymentType)[keyof typeof EPaymentType]
